module.exports = __webpack_public_path__ + "img/empty-follow-project.9b9c24e3.png";